import React, { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

import BookInfo from './book-info'

import { Book, StatusEnum } from '../../../../data/book/data-types'


type BookDialogProps = {
  book: Book | { title: string, isbn13: string },
  needsUpdate?: boolean
  onStatusUpdated?: (status: StatusEnum, newClubId?: number) => void
}

const BookDialog: React.FunctionComponent<BookDialogProps> = ({ book, needsUpdate, onStatusUpdated }) => {
	const history = useHistory()
	const location = useLocation()
	
	useEffect(() => {
		window.history.pushState({}, book.title!, `/book?isbn13=${book.isbn13}`)
		
		return () => {
			if (window.location.pathname === '/book' && window.location.search === `?isbn13=${book.isbn13}`) {
				history.replace(location)
			}
		}
	}, [book.isbn13])

	return (
		<Container>
			<BookInfo book={book} needsUpdate={needsUpdate} onStatusUpdated={onStatusUpdated}/>
		</Container>
	)
}

const Container = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
    max-width: 1024px;

	padding: 24px 16px;

	${up('tablet')} {
		padding: 64px 48px;
	}
`


export default BookDialog